import { Text, Stack, Heading, Box } from 'braid-design-system';
import React, { Fragment } from 'react';

import Header from 'src/components/Header/Header';

import Alliances from './components/Alliances/Alliances';
import BrandSearch from './components/BrandSearch/BrandSearch';
import FeaturedOpportunities from './components/FeaturedOpportunities/FeaturedOpportunities';
import FindAFranchiseOpp from './components/FindAFranchiseOpp/FindAFranchiseOpp';
import FranchiseeStories from './components/FranchiseeStories/FranchiseeStories';
import ReadyToBuy from './components/ReadyToBuy/ReadyToBuy';
import Section from './components/Section/Section';
import SellingAFranchise from './components/SellingAFranchise/SellingAFranchise';
import StartingOut from './components/StartingOut/StartingOut';

const Franchise = () => (
  <Fragment>
    <Header
      title="Buying a franchise"
      description="Buying a franchise? Whether you've just started or you're ready to buy, you'll find everything you need right here."
      url="/franchises-licensing-distribution"
    />
    <Box paddingY="xlarge">
      <Stack space="large">
        <Section>
          <Stack space="medium">
            <Heading level="1">Buying a franchise</Heading>
            <Text>
              Whether you&apos;ve just started or you&apos;re ready to buy,
              you&apos;ll find everything you need right here.
            </Text>
          </Stack>
        </Section>
        <StartingOut />
        <FindAFranchiseOpp />
        <FeaturedOpportunities />
        <ReadyToBuy />
        <BrandSearch />
        <FranchiseeStories />
        <SellingAFranchise />
        <Alliances />
      </Stack>
    </Box>
  </Fragment>
);

export default Franchise;
